import { render, staticRenderFns } from "./CmgRegionSwitchAlertModal.vue?vue&type=template&id=00061f9f&scoped=true&lang=pug"
import script from "./cmg-region-switch-alert-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-region-switch-alert-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRegionSwitchAlertModal.vue?vue&type=style&index=0&id=00061f9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00061f9f",
  null
  
)

export default component.exports